export default __webpack_public_path__ + "static/media/left_icon.cbe9cdc3.svg";